import { WebsocketActions } from './../redux/wstomp/websocket-actions';
import { TranslationService } from 'src/i18n/translation-service';
import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage-angular';
import { MenuController, NavController, Platform, ToastController, IonicModule } from '@ionic/angular';
import { SignInPage } from './pages/sign-in/sign-in.page';
import { Observable, Subscription } from 'rxjs';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/mygolf.data';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Dialogs } from '@awesome-cordova-plugins/dialogs/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
// import { App } from 'ionic';
import { PlayerHomeDataService } from 'src/redux/player-home';
import { SessionDataService } from 'src/redux/session';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ServerInfo } from 'src/data/server-info';
import { filter, map } from 'rxjs/operators';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { setChartDefaults } from 'src/charts/chart-globals';
import { TranslateService } from "@ngx-translate/core";
import { Location } from '@angular/common';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { register } from 'swiper/element/bundle';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class MyApp {
  @ViewChild(NavController) nav: NavController;
  labels = {};

  // make HelloIonicPage the root (or first) page
  rootPage: any = SignInPage;
  pages: Array<{ title: string, component: any }>;

  private disconnectSubscriber: Subscription;
  // private connectSubscriner: Subscription;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  showLogin: boolean;
  loggedIn: boolean = false;

  isBookingRegistrationEnabled: boolean;

  constructor(public platform: Platform,
    private Location: Location,
    public menu: MenuController,
    public toastCtl: ToastController,
    public statusBar: StatusBar,
    public network: Network,
    // public dialogs: Dialogs,
    private dialogs: Dialogs,
    public splashScreen: SplashScreen,
    // public app: IonApp,
    // public _ionicApp: IonicApp,
    public playerHomeService: PlayerHomeDataService,
    private sessionDataService: SessionDataService,
    private serverInfoService: ServerInfoService,
    private flightService: ClubFlightService,
    private translate: TranslateService,
    private translationCustomService: TranslationService,
    private mg2uUtils: mygolfUtils,
    private websocketActions: WebsocketActions) {

    this.initializeApp();
    this.mg2uUtils.getWebParams();
    this.setInitLanguage(this.translationCustomService.getLanguage());
    // enablePlayerAppBooking
    this.serverInfoService.serverInfo()
      .subscribe((data: ServerInfo) => {
        if (data) {
          this.isBookingRegistrationEnabled = data.enablePlayerAppBooking;
        }
      })

    platform.ready().then(() => {
      this.getAppAttribute();
      this.websocketActions.configure();

      // Do your thing...
      if (!this.platform.is('capacitor')) this.setupBackButtonBehavior();

    });

    // set our app's pages
    this.pages = [
    ];
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$.pipe(filter(Boolean), map((playerHome: PlayerHomeInfo) => playerHome.player))

  }

  checkName() {
    // let activePortal = this.nav.getActive();
    // let _msg = activePortal.component.name;
    let _msg = "";
    MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
  }

  private setupBackButtonBehavior() {

    // If on web version (browser)
    if (window.location.protocol !== "file:") {

      // Register browser back button action(s)
      window.onpopstate = (evt) => {

        // Close menu if open
        if (this.menu.isOpen()) {
          this.menu.close();
          return;
        }


        // Close any active modals or overlays
        //comment
        // let activePortal = this._ionicApp._loadingPortal.getActive() ||
        //   this._ionicApp._modalPortal.getActive() ||
        //   this._ionicApp._toastPortal.getActive() ||
        //   this._ionicApp._overlayPortal.getActive();

        // if (activePortal) {
        //   activePortal.dismiss();
        //   return;
        // }

        // Navigate back
        // if (this.app.getRootNav().canGoBack()) this.app.getRootNav().pop();

      };

      // // Fake browser history on each view enter
      // this.app.viewDidEnter.subscribe((app) => {
      //   history.pushState(null, null, "");
      // });

    }

  }

  initializeApp() {
    this.platform.ready().then(() => {
      setChartDefaults();
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.statusBar.show();
      this.statusBar.overlaysWebView(false);
      // this.statusBar.overlaysWebView(true);
      // StatusBar.hide();
      this.hideSplashScreen();
      // this.platform.backButton.subscribeWithPriority(101, () => {

      //comment navigate to previosu page or exit app
      // let nav = this.app.getRootNav();
      // let activeNav = this.app.getActiveNav();
      // if (nav === activeNav && nav.getActive() && nav.getActive().isFirst())
      //   this.confirmAndExit(nav);
      // else
      //   this.app.navPop();

      // });
      this.platform.backButton.subscribeWithPriority(10, (processNextHandler) => {
        this.Location.back();

      });

      this.disconnectSubscriber = this.network.onDisconnect()
        .subscribe(() => {
          MessageDisplayUtil.showErrorToast("You have lost your data connection.",
            this.platform, this.toastCtl, 3000, 'bottom');

        });

    });

    this.platform.ready().then(() => {
      document.addEventListener('backbutton', () => {
        // console.log("clicking on back button")
        //  if (this.navCtrl.canGoBack()) {
        //    this.platform.exitApp()
        //    return;
        //  }
        //  this.navCtrl.pop()
      }, false);
    });

    // this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
    //     this.showLogin = show;
    //     if (show) {
    //         // this.sessionDataService.getCurrentUser()
    //         //     .subscribe((currUser: CurrentUser) => {
    //         //         this.username.setValue(currUser.userName);
    //         //     });
    //     }

    // });

    this.sessionDataService.getSessionStatus().subscribe((data: any) => {
      // console.log("get session status ", data)
      if (data === 1) this.loggedIn = true;
      else if (data === 3) this.loggedIn = false;
      else this.loggedIn = false;
    })
  }

  openPage(page) {
    // close the menu when clicking a link from the menu
    this.menu.close();

    // navigate to the new page if it is not the current page
    // this.nav.push(page.component);
  }

  confirmAndExit(nav: NavController) {
    if (this.platform.is("cordova")) {
      // console.log("Native confirm dialog");


      this.dialogs.confirm("Do you want to exit myGolf2u ?", "Exit App", ["No", "Exit"])
        .then((result: any) => {
          if (result && result === 2) {
            // this.platform.exitApp();
            navigator['app'].exitApp();
          }
        });
    }
  }

  hideSplashScreen() {
    if (this.splashScreen && this.splashScreen.hide) {
      setTimeout(() => {
        this.splashScreen.hide();
      }, 100);
    }
  }

  onHomeClick() {
    if (this.disableFooterPage(3)) return false;
    // console.log("footer home click")
    // this.nav.popToRoot();//this.nav.setRoot(PlayerHomePage);
  }

  openProfile() {
    if (this.disableFooterPage(5)) return false;
    // this.nav.push(ProfilePage, {
    //   type: 'playerProfile',
    //   player: this.player$
    // });
  }


  onMyBookingsClick() {
    if (this.disableFooterPage(1)) return false;
    if (!this.isBookingRegistrationEnabled) {
      MessageDisplayUtil.showErrorToast("Booking & Registration feature will be coming soon.",
        this.platform, this.toastCtl, 3000, 'bottom');
      return false;
    }

    // if(this.fromClub) this.nav.push(BookingCalendarPage , {clubId: _clubId})
    // else this.nav.push(BookingHomePage);
    // this.nav.push(BookingHomePage);
  }

  onFAQClick() {
    if (this.disableFooterPage(4)) return false;
    // if(this.paymentClickedBoolean) return false;
    // this.nav.push(FaqPage)
  }


  onNotificationsClick() {
    if (this.disableFooterPage(2)) return false;
    // this.nav.push(NotificationsPage);
  }

  showFooterPage() {

    enum pageToExclude {
      'SetupPlayingCoursesPage',
      'FlightSetupPage',
      'CompetitionPlayersPage',
      'PlayerMg2uCreditsModal', //n4-4
      'RefundBookingPlayersModal',
      'CaddyScheduleDisplayPage',
      'ClubBookingListPage',
      'BookingCalendarPage',
    };

    let _showFooter = true;

    //commnet
    // let viewAll = this.nav.getAllChildNavs();
    // let activePortal = this.nav.getActive();
    // let name = activePortal.component.name;
    // let activeView = this.nav.getActive();

    //  if (activeView && activeView.instance && activeView.instance.appFooterHide) _showFooter = false;


    // this.nav.viewDidEnter.subscribe(item => {
    //   const viewController = item as ViewController;
    //   const n = viewController.name;
    //   name = viewController.name;
    //   const id = viewController.id;
    // });

    // for (let value in pageToExclude) {
    //   if (name.toLowerCase().includes(value.toLowerCase())) {
    //     _showFooter = false;
    //     continue;
    //   }
    // }

    return _showFooter


  }

  disableFooterPage(type?: number) {
    let _disableFooter = false;

    //comment
    // let activePortal = this.nav.getActive();
    // let name = activePortal.component.name;

    let name = "";

    if (type === 1) { //mybookings
      if (name === 'BookingHomePage') _disableFooter = true;
    } else if (type === 2) { //notifications
      if (name === 'NotificationsPage') {
        _disableFooter = true;
      }
      // NotificationsPage
    } else if (type === 3) { //home
      if (name === 'PlayerHomePage') {
        _disableFooter = true;
      }
      // BookingHomePage
    } else if (type === 4) { //FAQ
      if (name === 'FaqPage') _disableFooter = true;
      // FaqPage
    } else if (type === 5) { //profile
      if (name === 'ProfilePage')
        _disableFooter = true;
    }

    return _disableFooter;
  }


  appAttribute: any;
  showConsoleLog: boolean = false;
  getAppAttribute() {
    this.flightService.getAppAttributes()
      .subscribe((data: any) => {
        if (data) {
          data.filter((d) => {
            return d.page === 'mainApp'
          }).map((d) => {
            this.appAttribute = d
          });

          if (this.appAttribute) {
            if (this.appAttribute.showConsoleLog)
              this.showConsoleLog = this.appAttribute.showConsoleLog;
          }

        }
      }, (error) => {

      }, () => {
        // console.log = null;
        if (!this.showConsoleLog) {
          // console.log = function () { };
        }
        // else if(this.showConsoleLog && console && console.log) console.log = null;
      })
  }

  setInitLanguage(lang) {
    this.translate.currentLang = lang;
    this.translationCustomService.changeLanguage(lang);
    this.translate
      .get([
        "USER_NOT_LOGGED_IN",
        "LOGOUT_TITLE",
        "LOGOUT_DESCRIPTION",
        "YES",
        "NO",
        "EXIT_APPLICATION",
        "EXIT_CONFIRMATION"
      ])
      .subscribe(res => {
        for (let key in res) {
          this.labels[key] = res[key];
        }
      });
  }


}
